var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    style: {
      fill: "rgba(255, 255 ,255, .8)",
      stroke: "none"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2380 4775 c-421 -94 -710 -470 -687 -895 15 -285 157 -530 400 -688 163 -106 372 -156 560 -132 433 54 751 390 774 820 15 288 -116 569 -346 739 -77 58 -206 121 -296 146 -84 24 -319 29 -405 10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M661 4135 c-80 -23 -129 -47 -196 -98 -260 -197 -287 -585 -55 -817 109 -109 238 -163 390 -163 257 0 476 173 535 426 62 264 -92 546 -350 638 -79 28 -247 35 -324 14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4181 4135 c-80 -23 -129 -47 -196 -98 -260 -197 -287 -585 -55 -817 109 -109 238 -163 390 -163 257 0 476 173 535 426 62 264 -92 546 -350 638 -79 28 -247 35 -324 14z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2345 2714 c-297 -43 -470 -108 -655 -248 -203 -153 -337 -336 -410 -563 -69 -213 -86 -444 -74 -953 l9 -355 28 -57 c37 -75 98 -134 177 -172 l65 -31 1025 0 c1084 0 1116 1 1221 46 59 26 112 83 148 158 l26 56 3 491 c3 537 -2 610 -54 774 -132 421 -503 760 -914 836 -73 14 -531 27 -595 18z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M515 2694 c-218 -53 -409 -231 -481 -450 l-29 -89 0 -645 0 -645 23 -42 c35 -66 79 -110 140 -140 l57 -28 319 -3 c175 -2 329 -1 342 2 l24 6 -2 428 c-2 444 5 556 42 739 54 258 178 503 348 685 l45 48 -24 20 c-44 37 -183 100 -254 115 -96 20 -465 19 -550 -1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4051 2694 c-75 -16 -192 -69 -238 -108 l-33 -28 60 -66 c170 -191 278 -407 330 -661 35 -174 42 -302 41 -743 l-1 -428 24 -6 c13 -3 165 -4 337 -2 296 3 317 4 360 24 64 30 125 88 157 148 l27 51 0 640 0 640 -29 89 c-73 221 -265 399 -486 451 -87 20 -456 20 -549 -1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.917d9e7803301051f0f9a15f2b1b6c41.svg";
export { ForwardRef as ReactComponent };